import { toKebabCase } from "@utils/stringFormat";
import { TDocumentClass } from "../core";

interface ICreateDocumentRouteParams {
  taxRatesChannel?: string;
  invoiceType?: string;
  documentClass: TDocumentClass;
}

export const getCreateDocumentRoute = ({
  taxRatesChannel,
  invoiceType,
  documentClass,
}: ICreateDocumentRouteParams) => {
  const documentType = taxRatesChannel
    ? invoiceType
    : documentClass === "DeliveryNote"
    ? `Sale${documentClass}`
    : documentClass;

  return `/dashboard/documents/${
    taxRatesChannel ? `${taxRatesChannel.toLowerCase()}/` : ""
  }create-${toKebabCase(documentType!)}`;
};
